// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3o-15","title":"AfterFrontImage_title__1-40H"};